var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownloadAppStep(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 142,
    height: 137,
    viewBox: "0 0 142 137",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1211_18060)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 142,
    height: 137,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1211_18060)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M142 0H0V137H142V0Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.4922 126.183C27.4922 120.9 23.0546 116.617 17.5792 116.617C12.1038 116.617 7.66615 120.9 7.66615 126.183H13.5212H21.6371H27.4922Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.1207 104.477L67.6226 104.73L58.3309 121.896C57.8446 122.799 57.8784 123.881 58.4272 124.754C58.9733 125.625 59.951 126.156 61.0069 126.156H98.223V126.703H61.0069C59.7534 126.703 58.591 126.071 57.9409 125.037C57.2907 124.001 57.2491 122.714 57.829 121.643L67.1207 104.477Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.8617 104.586L70.3662 104.839L61.0563 122.078C60.8509 122.462 60.8664 122.919 61.0979 123.288C61.3293 123.657 61.7428 123.882 62.1901 123.882H98.444V124.429H62.1901C61.5452 124.429 60.9471 124.106 60.6116 123.571C60.2761 123.039 60.2553 122.377 60.5518 121.825L69.8617 104.586Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.7877 104.591L89.2948 104.839L79.0514 124.281L78.5469 124.033L88.7877 104.591Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.8726 104.712H70.1519L68.1094 108.677H86.8539L88.8726 104.712Z",
    fill: "#151515",
    stroke: "#151515",
    strokeWidth: 2,
    strokeMiterlimit: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.891 56.0562C108.883 53.4661 106.326 51.7402 103.482 51.7402C89.5818 51.7402 48.6659 51.7402 30.2971 51.7402C28.2078 51.7402 26.27 52.7268 25.0865 54.3843C23.932 56.0419 23.6531 58.16 24.3918 60.0593C28.8183 71.4404 36.5999 91.4479 40.009 100.213C41.0175 102.806 43.5736 104.529 46.4465 104.529C60.5785 104.529 102.626 104.529 120.531 104.529C122.417 104.529 124.162 103.642 125.206 102.149C126.28 100.657 126.496 98.7519 125.832 97.0431L109.891 56.0562Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.17 55.9628L126.111 96.9497C126.807 98.7409 126.57 100.743 125.437 102.306C124.334 103.873 122.52 104.803 120.546 104.803H46.4342C43.4744 104.803 40.8034 103.009 39.7529 100.308L24.136 60.1536C23.3641 58.169 23.6365 55.96 24.8492 54.2285C26.091 52.497 28.0993 51.4678 30.2757 51.4678H103.488C106.448 51.4678 109.119 53.2618 110.17 55.9628ZM109.635 56.1533C108.668 53.6684 106.225 52.0136 103.498 52.0136H30.2848C28.3116 52.0136 26.4443 52.9576 25.3192 54.5412C24.194 56.1249 23.9657 58.1492 24.6723 59.966L40.2881 100.117C41.2545 102.602 43.6971 104.257 46.4248 104.257H120.537C122.307 104.257 123.981 103.412 124.996 101.994C125.983 100.575 126.206 98.7609 125.574 97.1374L109.635 56.1533Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.165 55.96L126.021 96.7286C126.577 98.159 126.378 99.7513 125.508 100.998C124.609 102.244 123.148 102.988 121.595 102.988H48.0776C45.1132 102.988 42.467 101.193 41.4162 98.4912L25.5597 57.7227C25.0033 56.2922 25.2025 54.6999 26.0729 53.4534C26.9432 52.2069 28.4044 51.4629 29.9855 51.4629H103.475C106.439 51.4629 109.114 53.2584 110.165 55.96ZM109.645 56.1495C108.679 53.6648 106.229 52.012 103.491 52.012H30.0013C28.6179 52.012 27.3203 52.6682 26.5335 53.7664C25.7477 54.8674 25.5886 56.273 26.0788 57.5332L41.9353 98.3017C42.9017 100.786 45.3513 102.439 48.0899 102.439H121.579C122.963 102.439 124.26 101.783 125.047 100.685C125.805 99.5838 125.992 98.1782 125.502 96.918L109.645 56.1495Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.59401 126.158H133.406V126.706H8.59401V126.158Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.2994 60.9238H27.2188V61.4718H42.2994V60.9238Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.322 60.9238H93.6328V61.4718H112.322V60.9238Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.1559 54.8799C31.2826 54.8799 32.5044 55.7566 32.8991 56.8361C33.2937 57.9157 32.7129 58.7925 31.5862 58.7925C30.4878 58.7925 29.266 57.9157 28.8714 56.8361C28.4767 55.7566 29.0575 54.8799 30.1559 54.8799ZM30.159 55.4279C29.8492 55.4279 29.5805 55.5402 29.4332 55.7539C29.2639 55.9841 29.2685 56.3046 29.3977 56.6581C29.7152 57.5267 30.71 58.2445 31.5831 58.2445C31.9211 58.2445 32.1898 58.1322 32.337 57.9185C32.4772 57.6856 32.5018 57.3678 32.3726 57.0144C32.0551 56.1458 31.0604 55.4279 30.159 55.4279Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.2028 54.8799C37.3295 54.8799 38.5513 55.7566 38.946 56.8361C39.3406 57.9157 38.7598 58.7925 37.6331 58.7925C36.5346 58.7925 35.3129 57.9157 34.9183 56.8361C34.5236 55.7566 35.1043 54.8799 36.2028 54.8799ZM36.2059 55.4279C35.8961 55.4279 35.6273 55.5402 35.4801 55.7539C35.3108 55.9841 35.3153 56.3046 35.4445 56.6581C35.7621 57.5267 36.7569 58.2445 37.63 58.2445C37.968 58.2445 38.2367 58.1322 38.3839 57.9185C38.5241 57.6856 38.5487 57.3678 38.4195 57.0144C38.1019 56.1458 37.1072 55.4279 36.2059 55.4279Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.945 54.8799C43.0716 54.8799 44.2935 55.7566 44.6881 56.8361C45.0828 57.9157 44.502 58.7925 43.3753 58.7925C42.2768 58.7925 41.0551 57.9157 40.6604 56.8361C40.2658 55.7566 40.8465 54.8799 41.945 54.8799ZM41.9481 55.4279C41.6383 55.4279 41.3695 55.5402 41.2223 55.7539C41.053 55.9841 41.0575 56.3046 41.1867 56.6581C41.5042 57.5267 42.499 58.2445 43.3722 58.2445C43.7102 58.2445 43.9788 58.1322 44.1261 57.9185C44.2662 57.6856 44.2908 57.3678 44.1616 57.0144C43.8441 56.1458 42.8494 55.4279 41.9481 55.4279Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4922 18.0781H49.2848L53.8605 29.9193C53.8605 29.9193 64.5092 29.9193 64.529 29.9193C65.7297 29.9326 66.8018 30.6684 67.2226 31.7636L71.1446 41.9895C71.1446 41.9895 81.8326 41.9895 81.877 41.9895C83.0555 42.0027 84.109 42.7216 84.5249 43.7979L98.6288 78.7693H60.8385L54.2881 63.7673H44.089L43.8698 63.7881C42.573 63.7881 41.4087 62.9993 40.9529 61.8133L37.0757 51.7028L26.5891 51.7198C25.3318 51.7198 24.1959 50.9537 23.7508 49.8018L11.4922 18.0781Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.6134 20.4557C21.6703 20.2457 21.8767 20.0918 22.1534 20.0918C22.4737 20.0918 22.7646 20.2637 22.9544 20.4557C25.0319 22.5571 27.1093 24.6585 29.1867 26.76C29.394 26.9697 29.5346 27.255 29.4742 27.5243C29.425 27.7435 29.2174 27.9102 28.9286 27.9102C26.2809 27.9102 23.6333 27.9102 20.9857 27.9102C20.6536 27.9102 20.3538 27.7264 20.1634 27.5243C19.9639 27.3124 19.8305 27.0258 19.9026 26.76C20.4728 24.6585 21.043 22.5571 21.6134 20.4557Z",
    fill: "#9E007E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.8892 51.705H26.5328C27.5256 51.705 28.445 51.2245 28.9994 50.4168C29.5515 49.6091 29.6692 48.5763 29.3131 47.6495L23.9124 33.595C23.5868 32.7476 23.6968 31.8018 24.2089 31.066C24.7185 30.3302 25.5642 29.8969 26.4713 29.9064H26.6065C27.7591 29.9196 28.794 30.6385 29.2076 31.7148L36.8892 51.705Z",
    fill: "#151515",
    stroke: "#151515",
    strokeWidth: 1.71957,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.147 63.7851H43.7906C44.7835 63.7851 45.7028 63.3046 46.2572 62.4969C46.8093 61.6892 46.927 60.6564 46.5709 59.7295L41.1702 45.6751C40.8446 44.8276 40.9547 43.8819 41.4667 43.1461C41.9763 42.4103 42.822 41.977 43.7292 41.9865H43.8643C45.0169 41.9997 46.0518 42.7185 46.4654 43.7948L54.147 63.7851Z",
    fill: "#151515",
    stroke: "#151515",
    strokeWidth: 1.71957,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.865 29.6289C50.0225 29.6289 50.1484 29.7524 50.1484 29.9024C50.1484 30.0543 50.0225 30.178 49.865 30.178H27.3095C27.152 30.178 27.0261 30.0543 27.0261 29.9024C27.0261 29.7524 27.152 29.6289 27.3095 29.6289H49.865Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.1206 22.7324C47.2781 22.7324 47.4062 22.8559 47.4062 23.0059C47.4062 23.1578 47.2781 23.2815 47.1206 23.2815H31.3843C31.2289 23.2815 31.1009 23.1578 31.1009 23.0059C31.1009 22.8559 31.2289 22.7324 31.3843 22.7324H47.1206Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.2065 25.4639C48.364 25.4639 48.4922 25.5874 48.4922 25.7373C48.4922 25.8893 48.364 26.013 48.2065 26.013H32.4703C32.3149 26.013 32.1868 25.8893 32.1868 25.7373C32.1868 25.5874 32.3149 25.4639 32.4703 25.4639H48.2065Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.3204 32.2168C42.6481 32.2168 44.9478 33.9844 45.6958 36.07C46.3884 38.0016 45.3154 39.9231 43.0839 39.9231C40.7563 39.9231 38.4565 38.1555 37.7086 36.07C37.016 34.1384 38.0889 32.2168 40.3204 32.2168Z",
    fill: "#23286B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.8852 48.1112C61.6502 47.4565 60.9285 46.9023 60.1972 46.9023C58.3173 46.9023 56.4376 46.9023 54.5577 46.9023C53.8565 46.9023 53.5199 47.5055 53.7375 48.1112C54.3879 49.9258 55.0383 51.7392 55.6887 53.5525C55.9237 54.2085 56.6454 54.7627 57.3767 54.7627H63.0162C63.7174 54.7627 64.054 54.1595 63.8364 53.5525C63.186 51.7392 62.5356 49.9258 61.8852 48.1112Z",
    fill: "#428DFC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.2924 34.3145C65.4499 34.3145 65.5781 34.438 65.5781 34.5879C65.5781 34.7399 65.4499 34.8635 65.2924 34.8635H49.5562C49.4008 34.8635 49.2728 34.7399 49.2728 34.5879C49.2728 34.438 49.4008 34.3145 49.5562 34.3145H65.2924Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.2846 48.9785C82.4421 48.9785 82.5703 49.102 82.5703 49.252C82.5703 49.4039 82.4421 49.5276 82.2846 49.5276H66.5484C66.393 49.5276 66.265 49.4039 66.265 49.252C66.265 49.102 66.393 48.9785 66.5484 48.9785H82.2846Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.3706 37.0459C66.5281 37.0459 66.6562 37.1694 66.6562 37.3194C66.6562 37.4713 66.5281 37.595 66.3706 37.595H50.6343C50.4789 37.595 50.3509 37.4713 50.3509 37.3194C50.3509 37.1694 50.4789 37.0459 50.6343 37.0459H66.3706Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.3627 51.8125C83.5203 51.8125 83.6484 51.936 83.6484 52.086C83.6484 52.2379 83.5203 52.3616 83.3627 52.3616H67.6265C67.4711 52.3616 67.3431 52.2379 67.3431 52.086C67.3431 51.936 67.4711 51.8125 67.6265 51.8125H83.3627Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.7528 42.2609C48.596 42.2609 48.4688 42.1403 48.4688 41.9869C48.4688 41.8362 48.596 41.7129 48.7528 41.7129H73.7285C73.8853 41.7129 74.0126 41.8362 74.0126 41.9869C74.0126 42.1403 73.8853 42.2609 73.7285 42.2609H48.7528Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4888 17.8037H49.2789C49.3974 17.8037 49.5049 17.8775 49.5466 17.9853L54.0521 29.645C55.507 29.645 64.5113 29.6469 64.5286 29.6469C65.8454 29.6601 67.024 30.4659 67.4846 31.6709L71.3363 41.7152C72.7961 41.7152 81.8342 41.7152 81.8762 41.7152C83.1707 41.7284 84.3284 42.5191 84.7853 43.7013L98.8884 78.6709C98.9238 78.756 98.9135 78.8506 98.8605 78.9244C98.8107 79.0001 98.7237 79.0436 98.6323 79.0436H60.3901C60.2716 79.0436 60.1638 78.9698 60.1222 78.862L58.8542 75.5101L50.9796 55.6561C50.9223 55.5142 50.9944 55.3554 51.1394 55.3024C51.2844 55.2494 51.448 55.3212 51.5028 55.4631L59.3805 75.3191C59.3813 75.3209 59.382 75.3228 59.3827 75.3247L60.5808 78.495H98.2153L84.2621 43.8943C84.2621 43.8943 84.2614 43.8924 84.2606 43.8905C83.8871 42.9239 82.9365 42.2732 81.8781 42.2637C81.8312 42.2637 71.1456 42.2637 71.1456 42.2637C71.0271 42.2637 70.9201 42.1918 70.8777 42.0821L66.959 31.8581C66.5792 30.8688 65.609 30.2049 64.5276 30.1935C64.5103 30.1935 53.8615 30.1935 53.8615 30.1935C53.7429 30.1935 53.6361 30.1216 53.5945 30.0138L49.0882 18.3523H11.8983L24.0144 49.7071C24.4179 50.7513 25.4443 51.4455 26.5855 51.4455L37.0721 51.4284C37.1906 51.4284 37.2974 51.5003 37.3398 51.61L41.217 61.7205C41.6265 62.793 42.681 63.508 43.8515 63.5137L44.0565 63.4947C44.2112 63.4796 44.3526 63.5894 44.3691 63.7407C44.3849 63.8901 44.2736 64.0245 44.1189 64.0396L43.8997 64.0604C43.8906 64.0623 43.8807 64.0622 43.8708 64.0622C42.4579 64.0622 41.1835 63.1997 40.6885 61.9058L36.8815 51.977L26.5917 51.9921C25.2134 51.9921 23.9732 51.1542 23.4871 49.8963L11.2285 18.1726C11.2168 18.1423 11.2094 18.1102 11.2093 18.078C11.2092 17.9626 11.2808 17.8604 11.3914 17.8207C11.4216 17.8094 11.4542 17.8037 11.4888 17.8037Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.3984 77.0527L80.9253 76.8711L86.0835 90.9252L85.5187 91.1068L80.3984 77.0527Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.7373 65.3121C73.2695 63.9644 73.8977 62.3845 75.4617 62.1549C77.0658 61.9228 78.6032 63.1196 79.0844 64.5331C80.1404 67.6091 81.1831 70.6863 82.2391 73.7622C82.6936 75.11 82.0787 76.6899 80.5013 76.9194C78.9106 77.1516 77.36 75.9547 76.8787 74.5412C75.836 71.4653 74.78 68.3894 73.7373 65.3121Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.6719 66.8388L77.1991 66.6572L80.9263 76.8715L80.3994 77.0532L76.6719 66.8388Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.5645 85.1231L76.9683 84.6025L85.8007 90.9318L89.7983 84.9148L90.3803 85.2711L86.148 91.5758C86.1184 91.6497 86.0245 91.7018 85.9457 91.7182C85.8377 91.7319 85.745 91.7101 85.6978 91.658L76.5645 85.1231Z",
    fill: "#151515"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1211_18060"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 142,
    height: 137,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1211_18060"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 142,
    height: 137,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadAppStep);
export default __webpack_public_path__ + "static/media/download-app-step.1c74abc04c0eafb0e2151a8da1a22594.svg";
export { ForwardRef as ReactComponent };